export const NAYYA_PRIVACY_POLICY_URL = 'https://www.nayya.com/privacy-policy';

export const NAYYA_END_USER_TERMS_URL =
  'https://legal.nayya.com/end-user-terms/';
